import { PageContentAtom, ToolbarMolecule } from '@justomx/atlas-components'
import { StackAtom } from 'components/atoms/Stack.atom'
import { ProductCardOrganism } from 'components/organisms/ProductCard.organism'
import { usePalletDetail } from './PalletDetail.hook'

const PalletDetailPage = () => {
  const { actions, container, products } = usePalletDetail()

  return (
    <>
      <ToolbarMolecule
        title={container}
        actionIcon="ic_arrow_back"
        onAction={actions.onGoBack}
      />

      <PageContentAtom>
        <StackAtom $direction="column" $gap={16}>
          {products.map((product) => (
            <ProductCardOrganism
              key={product.barcode}
              quantityLabel="Cantidad registrada:"
              product={{
                ...product,
                quantity: product.processedQuantity.reduce(
                  (prev, curr) => prev + curr,
                  0
                ),
                containerId: ''
              }}
            />
          ))}
        </StackAtom>
      </PageContentAtom>
    </>
  )
}

export default PalletDetailPage
